// Home.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { FaPlay, FaPause, FaRedo } from 'react-icons/fa'; 
import axios from 'axios';  
import './Home.css'; 
// import SplashScreen from './SplashScreen'; // Import SplashScreen
import { useNavigate } from 'react-router-dom';
// import he from 'he';
import HomeAdv from './HomeAdv'; // 광고 컴포넌트 불러오기
import MusicPlay from './MusicPlay';
import YoutubePlay from './YoutubePlay';
import GenToken from './GenToken'; // 추가: GenToken 컴포넌트 import
// import Homehuggingface from "./Homehuggingface"; // Import the Hugging Face component
// import DoldariScene from "./DoldariScene"; // 돌다리 3D 씬 컴포넌트 불러오기 
// import ThreeDContainer from "./ThreeDContainer"; // 돌다리 3D 씬 컴포넌트 불러오기 
// import PendulumAnimation from "./PendulumAnimation";
// import SpaceAnimation from "./SpaceAnimation";

import { recordPageVisit } from './utils/pageVisitTracker';
import SimpleVisitCounter from './components/visit/SimpleVisitCounter';


function Home({ language, user, countryCode, userIp, showYoutube }) {
  const navigate = useNavigate(); // useNavigate 훅 사용
  const [webpageData, setWebpageData] = useState([]);
  const [sloganText, setSloganText] = useState(''); 
  const [tooltipVisible, setTooltipVisible] = useState(null);
  const [tooltipType, setTooltipType] = useState('');
  const [tooltipContent, setTooltipContent] = useState('');   

  const [activeTab, setActiveTab] = useState(''); // 현재 활성 탭을 추적  

  const SERVER_ROOT = process.env.REACT_APP_SERVER_ROOT || 'http://localhost:3001'; 
   

  // const inputRef = useRef(null); // Ref for the editable input
  const userId = user ? user.uid : 'unknown'; 

  const isMobile = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isMobileDevice = isMobile();  
 
  const userEmail = user ? user.email : 'unknown';
  console.log(`Home: user.email: ${userEmail}`);
  console.log(`Home: countryCode: ${countryCode}`);

  // const isValidUrl = (string) => {
  //   try {
  //     new URL(string);
  //     return true;
  //   } catch {
  //     return false;
  //   }
  // }; 

  const handleMouseEnter = (type, message) => {
    
    console.log(`type: ${type}`);
    console.log(`message: ${message}`);

    setTooltipType(type);
    setTooltipContent(message);
    setTooltipVisible(true); 
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  }; 

  // const handleTooltipClick = () => {
  //   if (isMobileDevice) setTooltipVisible(false);
  // };

  const getValueByName = (dataArray, name) => {
    const record = dataArray.find(record => record.name === name);
    return record ? record.value : null;
  }; 

  useEffect(() => {
    // countryCode가 유효할 때만 페이지 방문 기록
    if (countryCode && countryCode !== 'UNKNOWN') {
      console.log(`Recording page visit with countryCode: ${countryCode}`);
      recordPageVisit('Home', {
        userId,
        userEmail: user ? user.email : 'unknown',
        userIp,
        countryCode,
        SERVER_ROOT,
        language,
        isMobileDevice
      });
    }
  }, [countryCode]);

  useEffect(() => {
    const tableName = language !== 'KR' ? 'webpage_EN' : 'webpage';
    axios.get(`${SERVER_ROOT}/api/${tableName}`)
      .then((response) => {
        setWebpageData(response.data);
        const sloganRecord = response.data.find(item => item.name === 'App.js_slogun');
        if (sloganRecord) setSloganText(sloganRecord.value);
      })
      .catch((error) => console.error("Error fetching webpage data:", error));
  }, [language]);
  
  // function getDomain(url) {
  //   try {
  //     const siteUrl = new URL(url);
  //     const domain = `${siteUrl.hostname}`;
  //     return domain;
  //   } catch (error) {
  //     console.error('Invalid URL:', error);
  //     return null;
  //   }
  // }    
 
  if (isMobileDevice) {
    return (
    <div className="Home"> 
        {/* <header className="Home-header">
        </header> */}

        <main>
        <div className='HomeContainer'
        onClick={(e) => {
          // 클릭한 요소가 mySites의 자식 요소가 아니라면 스크롤 실행
          if (e.target === e.currentTarget) {
            window.scrollTo(0, 0);
          }
        }}>    
          
          {/* YouTube 플레이어 컴포넌트 */}
          {showYoutube && (
              <div className='YoutubePlayerContainer'>
                {/* <h3 style={{fontSize: '14px', color: 'white', marginBottom: '10px'}}>
                  {language === 'KR' ? '내 유튜브 재생목록' : 'My YouTube Playlist'}
                </h3>  */}
                {/* key 속성 추가 및 window.location.pathname을 통해 현재 경로가 바뀔 때마다 컴포넌트 재마운트 */}
                <YoutubePlay 
                  key={`youtube-player-${window.location.pathname}`} 
                  language={language}
                  user={user} 
                  countryCode={countryCode} 
                  userIp={userIp} 
                  forceReload={true} 
                />
                 
              </div>

              
            )}
 

          {/* <div className="thumbnail-generator-container">
            <img
              src={language !== 'KR' ? "/images/thumbnail_generator_EN.png": "/images/thumbnail_generator.png"} 
              alt="Thumbnail Generator"
              className="thumbnail-generator-image"
              onClick={() => window.open('/thumbnail', '_blank')}
              style={{
                cursor: 'pointer',
                width: '350px',
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? '감성 썸네일 생성기' : 'Emotional Thumbnail Generator'}</p>
          </div> */}

          <div className="convert-to-canon-container">
            <img
              src={language !== 'KR' ? "/images/canonConverter_EN.png": "/images/canonConverter.png"} 
              alt="Canon Converter"
              className="convert-to-canon-image"
              onClick={() => window.open('/convertToCanon', '_blank')}
              style={{
                cursor: 'pointer',
                width: '350px',
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? 'Canon 모드 변환기' : 'Canon Mode Converter'}</p>
          </div>

          {/* <div className="blog-editor-container">
            <img
              src={language !== 'KR' ? "/images/blogEditor_EN.png": "/images/blogEditor.png"} 
              alt="Blog Editor"
              className="blog-editor-image"
              onClick={() => window.open('/blogEditor', '_blank')}
              style={{
                cursor: 'pointer',
                width: '350px',
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? 'T-Story 블로그 편집기' : 'T-Story Blog Editor'}</p>
          </div> */}

          <div className='myHomeTitle'>   
              
            {/* 방문자 카운터 컴포넌트 추가 */}
            <div className="home-visit-counter">
              <SimpleVisitCounter 
                pageName="Home" 
                language={language} 
                SERVER_ROOT={SERVER_ROOT}
                refreshInterval={1000}
                userEmail={user ? user.email : ''}
                userIp={userIp}
                excludeLocalIp={true}  // 로컬 IP 제외 여부 직접 지정
                excludeAdminEmail={true}  // 관리자 이메일 제외 여부 직접 지정
              />
            </div>

            <div className="subtitles">
              {/* {user? ( */}
                <div className="home-tab-buttons"> 
                    
                    <img 
                      src={language !== 'KR' ? "/images/bookmarks.png": "/images/북마크아이콘2.png"} 
                      alt={language !== 'KR' ? 'My Selection' : '북마크'} 
                      onClick={() => {
                        // navigate('/homeBookmark'); 
                        window.open('/homeBookmark', '_bookmarkwindow'); 
                        setActiveTab('sitelist');
                      }}
                      onMouseEnter={() => handleMouseEnter(
                          'message', 
                          language === 'KR' ? '기억하고픈 링크를 여기에 붙여넣기 하세요.' : "Add new links and share to other people."
                      )}
                      onMouseOut={handleMouseLeave} 
                      style={{
                          height: '70px',
                          width: '70px', 
                          cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                          display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                          border: activeTab === 'sitelist' ? '3px solid orange' : 'none', 
                          borderRadius: '50%',
                      }}
                  /> 

                  <img 
                      src={language !== 'KR' ? "/images/learnplay.png": "/images/공부게임아이콘.png"} 
                      alt={language !== 'KR' ? 'Study' : '학습'} 
                      onClick={() => {
                        // navigate('/homeLearnPlay'); 
                        window.open('/homeLearnPlay', '_bookmarkwindow'); // '_blank'는 새 창에서 열기
                        setActiveTab('learnPlaylist');
                      }}
                      onMouseEnter={() => handleMouseEnter(
                          'message', 
                          language === 'KR' ? '기억하고픈 링크를 여기에 붙여넣기 하세요.' : "Add new links and share to other people."
                      )}
                      onMouseOut={handleMouseLeave} 
                      style={{
                          height: '70px',
                          width: '70px', 
                          cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                          display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                          border: activeTab === 'learnPlaylist' ? '3px solid orange' : 'none', 
                          borderRadius: '50%',
                      }}
                  />
                  
                      

                  <img 
                      src={language !== 'KR' ? "/images/memoDiary.png": "/images/메모일기장.png"} 
                      alt={language !== 'KR' ? "Memo" : '메모일기장'} 
                      onClick={() => {
                        // navigate('/homeUtility'); 
                        window.open('/homeUtility', '_bookmarkwindow'); 
                        setActiveTab('utilitylist');
                      }}
                      onMouseEnter={() => handleMouseEnter(
                          'message', 
                          language === 'KR' ? '이 버튼을 누르면 유명한 사이트 모음이 나옵니다.' : "Click the button and see the well-known sites."
                      )}
                      onMouseOut={handleMouseLeave} 
                      style={{
                          height: '70px',
                          width: '70px', 
                          cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                          display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                          border: activeTab === 'utilitylist' ? '3px solid orange' : 'none', 
                          borderRadius: '50%',
                      }}
                  />

                  <img 
                      src={language !== 'KR' ? "/images/shared.png": "/images/공유받은링크.png"} 
                      alt={language !== 'KR' ? 'Invited Contents' : '초대 콘텐츠'} 
                      onClick={() => {
                        // navigate('/homeShared');  
                        window.open('/homeShared', '_bookmarkwindow');  
                        setActiveTab('sharedlist');
                      }}
                      onMouseEnter={() => handleMouseEnter(
                          'message', 
                          language === 'KR' ? '기억하고픈 링크를 여기에 붙여넣기 하세요.' : "Add new links and share to other people."
                      )}
                      onMouseOut={handleMouseLeave} 
                      style={{
                          height: '70px',
                          width: '70px', 
                          cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                          display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                          border: activeTab === 'sharedlist' ? '3px solid orange' : 'none', 
                          borderRadius: '50%',
                      }}
                  />
                </div> 
              
            </div>
          </div>   
              
          {/* <div className="homeContents"> */}

            
             
          <div className="home-clipboard-container">
            <img
              src={language !== 'KR' ? "/images/homeclipboard_EN.png": "/images/homeclipboard.png"} 
              alt="Clipboard"
              className="home-clipboard-image"
              // onClick={() => navigate('/clipboard')} // 클릭 시 /clipboard 경로로 이동 
              onClick={() => window.open('/clipboard', '_blank')} // '_blank'는 새 창에서 열기
              style={{
                cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                width: '350px', // 이미지 크기 설정
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? '메모 & 일기 쓰기 클립보드' : 'Clipboard for Memo & Diary'}</p> {/* 다국어 지원 */}
          </div> 

          <div className="HFLedger-container">
            <img
              src={language !== 'KR' ? "/images/HomeFin_EN.png": "/images/HomeFin.png"} 
              alt="HFLedger"
              className="HFLedger-image"
              // onClick={() => navigate('/clipboard')} // 클릭 시 /clipboard 경로로 이동 
              onClick={() => window.open('/HFLedger', '_blank')} // '_blank'는 새 창에서 열기
              style={{
                cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                width: '350px', // 이미지 크기 설정
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? '가계부' : 'Home Financial Ledger'}</p> {/* 다국어 지원 */}
          </div> 


 
          {/* <div className="pendulum-animation-container" style={{ marginBottom: '20px', marginTop: '20px' }}>
            <PendulumAnimation /> 
          </div>   */}

          
          
          <div className='home-qrservice-container'>  

            <div className="home-directQRCreator-container">
              <img
                src={language !== 'KR' ? "/images/DirectQRCreator_EN.png": "/images/DirectQRCreator.png"} 
                alt="QR Scanner"
                className="home-directQRCreator-image"
                onClick={() => window.open('/directQRCreator', '_blank')}
                style={{
                  cursor: 'pointer',
                  width: '100%',
                  height: 'auto',
                }}
              />
              <p style={{fontSize: '12px'}}>{language === 'KR' ? 'QR 코드 생성기' : 'QR Code Creator'}</p>
            </div>


            <div className="home-qr-container">
              <img
                src={language !== 'KR' ? "/images/QRmessenger_EN.png": "/images/QRmessenger.png"} 
                alt="QR Message"
                className="home-qr-image"
                onClick={() => window.open('/qr', '_blank')}
                style={{
                  cursor: 'pointer',
                  width: '100%',
                  height: 'auto',
                }}
              />
              <p style={{fontSize: '12px'}}>{language === 'KR' ? 'QR 코드 메신저' : 'QR Code Messenger'}</p>
            </div>

            <div className="home-qrScanner-container">
              <img
                src={language !== 'KR' ? "/images/QRScanner_EN.png": "/images/QRScanner.png"} 
                alt="QR Scanner"
                className="home-qrScanner-image"
                onClick={() => window.open('/qrScanner', '_blank')}
                style={{
                  cursor: 'pointer',
                  width: '100%',
                  height: 'auto',
                }}
              />
              <p style={{fontSize: '12px'}}>{language === 'KR' ? 'QR 코드 스캐너' : 'QR Code Scanner'}</p>
            </div>
          </div>

          {/* 음악 플레이어 컴포넌트 */}
          <div className='MusicPlayerContainer'> 
          <MusicPlay 
            language={language} 
            user={user} 
            countryCode={countryCode} 
            userIp={userIp} 
          />
          </div>

          {/* 기타 시뮬레이터 컨테이너 */}
          <div className="guitar-simulator-section">
            <img
              src={language !== 'KR' ? "/images/guitarSimulator_EN.png": "/images/guitarSimulator.png"} 
              alt="Guitar Simulator"
              className="guitar-simulator-image"
              onClick={() => window.open('/guitarSimulator', '_blank')}
              style={{
                cursor: 'pointer',
                width: '350px',
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? 'ê¸°íƒ€ ì½"ë"œ ì˜¨ë¼ì¸ í•™ìŠµê¸°' : 'Guitar Chord Online Learning Tool'}</p>
          </div>

          {/* 오디오 스펙트럼 분석기 컨테이너 */}
          {user?.email === 'gategil1149@gmail.com' && (
          <div className="audio-spectrum-container">
            <img
              src={language !== 'KR' ? "/images/audioSpectrum_EN.png": "/images/audioSpectrum.png"} 
              alt="Audio Spectrum Analyzer"
              className="audio-spectrum-image"
              onClick={() => window.open('/audioSpectrum', '_blank')}
              style={{
                cursor: 'pointer',
                width: '350px',
                height: 'auto',
              }}
            />
            <p style={{fontSize: '12px'}}>{language === 'KR' ? '오디오 스펙트럼 분석기' : 'Audio Spectrum Analyzer'}</p>
          </div>
          )}

          {/* Hugging Face 컨테이너 */}
          <div className="huggingface-section">
              <img 
                src={language === 'KR' ? "/images/homehuggingface.png": "/images/homehuggingface_EN.png"} 
                alt="Clipboard"
                className="home-clipboard-image"
                // onClick={() => window.location.href = 'https://huggingface.co/spaces/black-forest-labs/FLUX.1-schnell'}
                onClick={() => window.open('https://huggingface.co/spaces/black-forest-labs/FLUX.1-schnell', '_blank')} // '_blank'는 새 창에서 열기
                style={{
                  cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                  width: '350px', // 이미지 크기 설정
                  height: 'auto',
                }}
              />
              <p style={{fontSize: '12px'}}>{language === 'KR' ? 'Huggingface 이미지 생성성' : 'Huggingface image creation'}</p> {/* 다국어 지원 */}

          </div>  

          {/* <div className="space-animation-container" style={{ marginBottom: '20px', marginTop: '20px' }}>
            <SpaceAnimation /> 
          </div>   */}


          {/* Solana 토큰 생성 컨테이너 추가 */}
          {/* <div className='GeneTokenContainer'>
            <GenToken language={language} user={user} SERVER_ROOT={SERVER_ROOT} />
          </div> */}

          {user?.email === 'gategil1149@gmail.com' && (
            <div className="GeneTokenContainer">
              <img
                  src={language !== 'KR' ? "/images/solanaTokenGen.png": "/images/solanaTokenGen.png"} 
                  alt="GenToken"
                  className="GeneToken-image" 
                  onClick={() => window.open('/gentoken', '_blank')} // '_blank'는 새 창에서 열기
                  style={{
                    cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                    width: '60%', // 이미지 크기 설정
                    height: 'auto',
                  }}
                /> 
            </div> 
          )}
 
          
          <div className='advertisement' style={{
                  cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                  width: '100%', // 이미지 크기 설정
                  height: 'auto',
                }}>
              <HomeAdv />
            </div>  
          
          <div className="TGabyss" style={{marginBottom: '100px'}}>
                <Link to="/intro" style={{ color: 'white', backgroundColor: '#269830', textDecoration: 'none' }}> TG ABYSS Corp. </Link> &copy; All Rights Reserved. &nbsp;  
                <div style={{ color: 'white', backgroundColor: '#269830', textDecoration: 'none' }}>
                {/* {getValueByName(webpageData, 'App.js_ceoText') || "대표"}: &nbsp; */}
                {/* {getValueByName(webpageData, 'App.js_ceoName') || "길계태"}, &nbsp; */}
                {getValueByName(webpageData, 'App.js_ceoEmail') || "gategil1149@gmail.com"}
                  {/* | &nbsp;  */}
                {/* {getValueByName(webpageData, 'App.js_phoneText') || "대표번호"}: &nbsp; */}
                {/* {getValueByName(webpageData, 'App.js_phoneNumber') || "010-7235-5108"} &nbsp;  */}
                {/* {getValueByName(webpageData, 'App.js_companyAddressText') || "주소"}: &nbsp; */}
                {/* {getValueByName(webpageData, 'App.js_companyAddress') || "대전시 유성구 관들4길 3 (관평동)"}   */}
                </div>
                
                {user?.email === 'gategil1149@gmail.com' && (
                  <button
                    className="manage-button"
                    // onClick={() => {
                    //   navigate('/manage'); // Use React Router navigation
                    // }}
                    onClick={() => window.open('/manage', '_blank')} // '_blank'는 새 창에서 열기
                    style={{
                      backgroundColor: '#269830',
                      color: 'white',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      marginLeft: '10px',
                      border: 'none',
                    }}
                  >
                    {language === 'KR' ? '관리' : 'Manage'}
                  </button>
                )}
          </div>     

        </div>
        </main>
    </div>
    );
  } else {  /* Desktop PC */
    return (
      <div className="Home"> 
          {/* <header className="Home-header">
          </header> */}

          <main>
          <div className='HomeContainer'
          onClick={(e) => {
            // 클릭한 요소가 mySites의 자식 요소가 아니라면 스크롤 실행
            if (e.target === e.currentTarget) {
              window.scrollTo(0, 0);
            }
          }}>  
                

            <div className='myHomeContent' style={{width: '100vw'}}>
              {/* YouTube 플레이어 컴포넌트 */}
              {showYoutube && (
                  <div className='YoutubePlayerContainer'>
                    {/* <h3 style={{fontSize: '14px', color: 'white', marginBottom: '10px'}}>
                      {language === 'KR' ? '내 유튜브 재생목록' : 'My YouTube Playlist'}
                    </h3>  */}
                    {/* key 속성 추가 및 window.location.pathname을 통해 현재 경로가 바뀔 때마다 컴포넌트 재마운트 */}
                    <YoutubePlay 
                      key={`youtube-player-${window.location.pathname}`} 
                      language={language}
                      user={user} 
                      forceReload={true} 
                    />
                  </div>
               )}  
                
              <div className='right-side-containter' style={{width: showYoutube? '30%' : '100vw'}}>
                <div className='myHomeTitle'>   
                  
                  {/* 방문자 카운터 컴포넌트 추가 */}
                  <div className="home-visit-counter" style={{width: showYoutube? '100%' : '50%', 
                    margin: '0 auto',
                    textAlign: 'center'}} >
                    <SimpleVisitCounter 
                      pageName="Home" 
                      language={language} 
                      SERVER_ROOT={SERVER_ROOT}
                      refreshInterval={1000}
                      userEmail={user ? user.email : ''}
                      userIp={userIp}
                      excludeLocalIp={true}  // 로컬 IP 제외 여부 직접 지정
                      excludeAdminEmail={true}  // 관리자 이메일 제외 여부 직접 지정
                    />
                  </div>

                  <div className="subtitles"  style={{width: showYoutube? '100%' : '50%', 
                    margin: '10px auto',
                    textAlign: 'center'}} >
                    {/* {user? ( */}
                      <div className="home-tab-buttons"> 
                          
                          <img 
                            src={language !== 'KR' ? "/images/bookmarks.png": "/images/북마크아이콘2.png"} 
                            alt={language !== 'KR' ? 'My Selection' : '북마크'} 
                            onClick={() => {
                              window.open('/homeBookmark', '_bookmarkwindow') // '_blank'는 새 창에서 열기
                              setActiveTab('sitelist');
                            }}
                            onMouseEnter={() => handleMouseEnter(
                                'message', 
                                language === 'KR' ? '기억하고픈 링크를 여기에 붙여넣기 하세요.' : "Add new links and share to other people."
                            )}
                            onMouseOut={handleMouseLeave} 
                            style={{
                                height: '70px',
                                width: '70px', 
                                cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                                display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                                border: activeTab === 'sitelist' ? '3px solid orange' : 'none', 
                                borderRadius: '50%',
                            }}
                        /> 

                        <img 
                            src={language !== 'KR' ? "/images/learnplay.png": "/images/공부게임아이콘.png"} 
                            alt={language !== 'KR' ? 'Study' : '학습'} 
                            onClick={() => {
                              // navigate('/homeLearnPlay');  
                              window.open('/homeLearnPlay', '_bookmarkwindow'); // '_blank'는 새 창에서 열기
                              setActiveTab('learnPlaylist');
                            }}
                            onMouseEnter={() => handleMouseEnter(
                                'message', 
                                language === 'KR' ? '기억하고픈 링크를 여기에 붙여넣기 하세요.' : "Add new links and share to other people."
                            )}
                            onMouseOut={handleMouseLeave} 
                            style={{
                                height: '70px',
                                width: '70px', 
                                cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                                display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                                border: activeTab === 'learnPlaylist' ? '3px solid orange' : 'none', 
                                borderRadius: '50%',
                            }}
                        />
                        
                          

                        <img 
                            src={language !== 'KR' ? "/images/memoDiary.png": "/images/메모일기장.png"} 
                            alt={language !== 'KR' ? "Memo" : '메모일기장'} 
                            onClick={() => {
                              // navigate('/homeUtility'); 
                              window.open('/homeUtility', '_bookmarkwindow'); // '_blank'는 새 창에서 열기
                              setActiveTab('utilitylist');
                            }}
                            onMouseEnter={() => handleMouseEnter(
                                'message', 
                                language === 'KR' ? '이 버튼을 누르면 유명한 사이트 모음이 나옵니다.' : "Click the button and see the well-known sites."
                            )}
                            onMouseOut={handleMouseLeave} 
                            style={{
                                height: '70px',
                                width: '70px', 
                                cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                                display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                                border: activeTab === 'utilitylist' ? '3px solid orange' : 'none', 
                                borderRadius: '50%',
                            }}
                        />

                        <img 
                            src={language !== 'KR' ? "/images/shared.png": "/images/공유받은링크.png"} 
                            alt={language !== 'KR' ? 'Invited Contents' : '초대 콘텐츠'} 
                            onClick={() => {
                              // navigate('/homeShared');  
                              window.open('/homeShared', '_bookmarkwindow'); // '_blank'는 새 창에서 열기
                              setActiveTab('sharedlist');
                            }}
                            onMouseEnter={() => handleMouseEnter(
                                'message', 
                                language === 'KR' ? '기억하고픈 링크를 여기에 붙여넣기 하세요.' : "Add new links and share to other people."
                            )}
                            onMouseOut={handleMouseLeave} 
                            style={{
                                height: '70px',
                                width: '70px', 
                                cursor: 'pointer', // 버튼처럼 보이도록 마우스 포인터 변경
                                display: 'block', // 다른 요소들과 구분되도록 블록 레벨 설정
                                border: activeTab === 'sharedlist' ? '3px solid orange' : 'none', 
                                borderRadius: '50%',
                            }}
                        />
                      </div> 
                    
                  </div>
              </div>
                <div className="home-clipboard-container"  style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/homeclipboard_EN.png": "/images/homeclipboard.png"} 
                    alt="Clipboard"
                    className="home-clipboard-image"
                    // onClick={() => navigate('/clipboard')} // 클릭 시 /clipboard 경로로 이동 
                    onClick={() => window.open('/clipboard', '_blank')} // '_blank'는 새 창에서 열기
                    style={{
                      cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                      width: '100%', // 이미지 크기 설정
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? '메모 & 일기 쓰기 클립보드' : 'Clipboard for Memo & Diary'}</p> {/* 다국어 지원 */}
                </div> 

                <div className="thumbnail-generator-container" style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/thumbnail_generator_EN.png": "/images/thumbnail_generator.png"} 
                    alt="Thumbnail Generator"
                    className="thumbnail-generator-image"
                    onClick={() => window.open('/thumbnail', '_blank')}
                    style={{
                      cursor: 'pointer',
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? '감성 썸네일 생성기' : 'Emotional Thumbnail Generator'}</p>
                </div>

                <div className="convert-to-canon-container" style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/canonConverter_EN.png": "/images/canonConverter.png"} 
                    alt="Canon Converter"
                    className="convert-to-canon-image"
                    onClick={() => window.open('/convertToCanon', '_blank')}
                    style={{
                      cursor: 'pointer',
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? 'Canon 모드 변환기' : 'Canon Mode Converter'}</p>
                </div>

                <div className="blog-editor-container" style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/blogEditor_EN.png": "/images/blogEditor.png"} 
                    alt="Blog Editor"
                    className="blog-editor-image"
                    onClick={() => window.open('/blogEditor', '_blank')}
                    style={{
                      cursor: 'pointer',
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? 'T-Story 블로그 편집기' : 'T-Story Blog Editor'}</p>
                </div>


                <div className="HFLedger-container" style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/HomeFin_EN.png": "/images/HomeFin.png"} 
                    alt="HFLedger"
                    className="HFLedger-image"
                    // onClick={() => navigate('/clipboard')} // 클릭 시 /clipboard 경로로 이동 
                    onClick={() => window.open('/HFLedger', '_blank')} // '_blank'는 새 창에서 열기
                    style={{
                      cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                      width: '100%', // 이미지 크기 설정
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? '가계부' : 'Home Financial Ledger'}</p> {/* 다국어 지원 */}
                </div> 
      
                {/* <div className="pendulum-animation-container" style={{ marginBottom: '20px', marginTop: '20px' }}>
                  <PendulumAnimation /> 
                </div>   */}

                <div className='home-qrservice-container'  style={{width: showYoutube? '100%' : '50%', margin: '10px auto',
                  textAlign: 'center', display: 'flex', justifyContent: 'center'}}> 
                  <div className="home-directQRCreator-container">
                    <img
                      src={language !== 'KR' ? "/images/DirectQRCreator_EN.png": "/images/DirectQRCreator.png"} 
                      alt="QR Scanner"
                      className="home-directQRCreator-image"
                      onClick={() => window.open('/directQRCreator', '_blank')}
                      style={{
                        cursor: 'pointer',
                        width: '113px',
                        height: 'auto',
                      }}
                    />
                    <p style={{fontSize: '12px'}}>{language === 'KR' ? 'QR 코드 생성기' : 'QR Code Creator'}</p>

                  </div>

                  <div className="home-qr-container">
                    <img
                      src={language !== 'KR' ? "/images/QRmessenger_EN.png": "/images/QRmessenger.png"} 
                      alt="QR Message"
                      className="home-qr-image"
                      onClick={() => window.open('/qr', '_blank')}
                      style={{
                        cursor: 'pointer',
                        width: '113px',
                        height: 'auto',
                      }}
                    />
                    <p style={{fontSize: '12px'}}>{language === 'KR' ? 'QR 코드 메신저' : 'QR Code Messenger'}</p>
                  </div>

                  <div className="home-qrScanner-container">
                    <img
                      src={language !== 'KR' ? "/images/QRScanner_EN.png": "/images/QRScanner.png"} 
                      alt="QR Scanner"
                      className="home-qrScanner-image"
                      onClick={() => window.open('/qrScanner', '_blank')}
                      style={{
                        cursor: 'pointer',
                        width: '113px',
                        height: 'auto',
                      }}
                    />
                    <p style={{fontSize: '12px'}}>{language === 'KR' ? 'QR 코드 스캐너' : 'QR Code Scanner'}</p>
                  </div>
                </div>
                {/* 음악 플레이어 컴포넌트 */}
                <div className='MusicPlayerContainer' style={{width: showYoutube? '100%' : '50%', margin: '10px auto',
                  textAlign: 'center'}}> 
                <MusicPlay 
                  language={language} 
                  user={user} 
                  countryCode={countryCode} 
                  userIp={userIp} 
                />
                </div>

                {/* 기타 시뮬레이터 컨테이너 */}
                <div className="guitar-simulator-section" style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/guitarSimulator_EN.png": "/images/guitarSimulator.png"} 
                    alt="Guitar Simulator"
                    className="guitar-simulator-image"
                    onClick={() => window.open('/guitarSimulator', '_blank')}
                    style={{
                      cursor: 'pointer',
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? 'ê¸°íƒ€ ì½"ë"œ ì˜¨ë¼ì¸ í•™ìŠµê¸°' : 'Guitar Chord Online Learning Tool'}</p>
                </div>

                {/* 오디오 스펙트럼 분석기 컨테이너 */}
                <div className="audio-spectrum-container" style={{width: showYoutube? '100%' : '50%', 
                  margin: '10px auto',
                  textAlign: 'center'}} >
                  <img
                    src={language !== 'KR' ? "/images/audioSpectrum_EN.png": "/images/audioSpectrum.png"} 
                    alt="Audio Spectrum Analyzer"
                    className="audio-spectrum-image"
                    onClick={() => window.open('/audioSpectrum', '_blank')}
                    style={{
                      cursor: 'pointer',
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                  <p style={{fontSize: '12px'}}>{language === 'KR' ? '오디오 스펙트럼 분석기' : 'Audio Spectrum Analyzer'}</p>
                </div>

                

                {/* Hugging Face 컨테이너 */}
                <div className="huggingface-section" style={{width: showYoutube? '100%' : '50%', margin: '10px auto',
                  textAlign: 'center'}}>
                    <img 
                      src={language === 'KR' ? "/images/homehuggingface.png": "/images/homehuggingface_EN.png"} 
                      alt="Clipboard"
                      className="home-clipboard-image"
                      // onClick={() => window.location.href = 'https://huggingface.co/spaces/black-forest-labs/FLUX.1-schnell'}
                      onClick={() => window.open('https://huggingface.co/spaces/black-forest-labs/FLUX.1-schnell', '_blank')} // '_blank'는 새 창에서 열기
                      style={{
                        cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                        width: '100%', // 이미지 크기 설정
                        height: 'auto',
                      }}
                    />
                    <p style={{fontSize: '12px'}}>{language === 'KR' ? 'Huggingface 이미지 생성성' : 'Huggingface image creation'}</p> {/* 다국어 지원 */}

                </div>  

                {/* <div className="space-animation-container" style={{ marginBottom: '20px', marginTop: '20px' }}>
                  <SpaceAnimation /> 
                </div>   */}

                {user?.email === 'gategil1149@gmail.com' && (
                  <div className="GeneTokenContainer" style={{width: showYoutube? '100%' : '50%', margin: '10px auto',
                  textAlign: 'center'}}>
                    <img
                      src={language !== 'KR' ? "/images/solanaTokenGen.png": "/images/solanaTokenGen.png"} 
                      alt="GenToken"
                      className="GeneToken-image" 
                      onClick={() => window.open('/gentoken', '_blank')} // '_blank'는 새 창에서 열기
                      style={{
                        cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                        width: '100%', // 이미지 크기 설정
                        height: 'auto',
                      }}
                    /> 
                  </div> 
                )}
      
                
                <div className='advertisement' style={{
                        cursor: 'pointer', // 버튼처럼 보이도록 커서를 변경
                        width: showYoutube? '100%' : '50%', // 이미지 크기 설정
                        height: 'auto', 
                        margin: '10px auto',
                        textAlign: 'center'
                      }}>
                    <HomeAdv />
                  </div>  
                
                <div className="TGabyss" style={{marginBottom: '100px', width: showYoutube? '100%' : '50%', margin: '10px auto',
                  textAlign: 'center'}}>
                      <Link to="/intro" style={{ color: 'white', backgroundColor: '#269830', textDecoration: 'none' }}> TG ABYSS Corp. </Link> &copy; All Rights Reserved. &nbsp;  
                      <div style={{ color: 'white', backgroundColor: '#269830', textDecoration: 'none' }}>
                      {/* {getValueByName(webpageData, 'App.js_ceoText') || "대표"}: &nbsp; */}
                      {/* {getValueByName(webpageData, 'App.js_ceoName') || "길계태"}, &nbsp; */}
                      {getValueByName(webpageData, 'App.js_ceoEmail') || "gategil1149@gmail.com"}
                        {/* | &nbsp;  */}
                      {/* {getValueByName(webpageData, 'App.js_phoneText') || "대표번호"}: &nbsp; */}
                      {/* {getValueByName(webpageData, 'App.js_phoneNumber') || "010-7235-5108"} &nbsp;  */}
                      {/* {getValueByName(webpageData, 'App.js_companyAddressText') || "주소"}: &nbsp; */}
                      {/* {getValueByName(webpageData, 'App.js_companyAddress') || "대전시 유성구 관들4길 3 (관평동)"}   */}
                      </div>
                      
                      {user?.email === 'gategil1149@gmail.com' && (
                        <button
                          className="manage-button"
                          // onClick={() => {
                          //   navigate('/manage'); // Use React Router navigation
                          // }}
                          onClick={() => window.open('/manage', '_blank')} // '_blank'는 새 창에서 열기
                          style={{
                            backgroundColor: '#269830',
                            color: 'white',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            marginLeft: '10px',
                            border: 'none',
                          }}
                        >
                          {language === 'KR' ? '관리' : 'Manage'}
                        </button>
                      )}
                </div>     
              </div>  
            </div> 
          </div>
          </main>
      </div>
    );
  }
}

export default Home;